import AccountCircleTwoToneIcon from '@mui/icons-material/AccountCircleTwoTone'
import CalendarTodayOutlinedIcon from '@mui/icons-material/CalendarTodayOutlined'

import DirectionsCarIcon from '@mui/icons-material/DirectionsCar'
import PhoneIcon from '@mui/icons-material/Phone'
import { Box } from '@mui/material'
import IconInfo from 'components/Bookings/Confirmation/IconInfo'
import React from 'react'
import NumberPlate from './NumberPlate'

interface Props {
  data: any
}

const StatusInProgress: React.FC<Props> = (props) => {
  const { data } = props
  console.log('data', data)
  const driver = data?.tracking?.driver
  const vehicle = data?.tracking?.driver?.vehicle
  const vehicleDescription = [vehicle?.colour?.toUpperCase(), vehicle?.makeAndModel]
    .filter(Boolean)
    .join(' ')

  const Reply = () => {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'space-evenly' }}>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <IconInfo
            Icon={AccountCircleTwoToneIcon}
            title="Driver"
            value={driver?.name ?? ''}
          />
          <IconInfo
            Icon={PhoneIcon}
            title="Mobile"
            value={driver?.contactNumber ?? ''}
          />
        </Box>
        <Box sx={{ display: 'flex', flexDirection: 'column' }}>
          <IconInfo
            Icon={DirectionsCarIcon}
            title="Vehicle"
            value={vehicleDescription}
          />
          <IconInfo
            Icon={CalendarTodayOutlinedIcon}
            title="Registration"
            component={
              <NumberPlate
                chars={vehicle?.registrationNumber}
                tz={data?.timeZone}
                size="small"
              />
            }
          />
        </Box>
      </Box>
    )
  }

  return <Reply />
}

export default StatusInProgress
